{
  "defaultTitle": "No se pudo registrar",
  "defaultMessage": "Por favor confirma la información con tu despachador o contacta al almacén",
  "backToHomescreen": "Volver a la pantalla de inicio",
  "hideErrorLog": "OCULTAR REGISTRO DE ERRORES",
  "viewErrorLog": "VER REGISTRO DE ERRORES",
  "errorLogMessageLabel": "Mensaje:",
  "errorLogStatusLabel": "Código de estado:",
  "unknown": "Desconocido"
}
